module.exports = __webpack_public_path__ + "static/media/logo.2f028ad6.svg";